import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-xl mb-20" }, "Log in to your account", -1)
const _hoisted_4 = { class: "role-selection mt-10 mb-20" }
const _hoisted_5 = { class: "pdr-15" }
const _hoisted_6 = { class: "pdr-15" }
const _hoisted_7 = { class: "pdr-15" }
const _hoisted_8 = { class: "inputs-wrapper w-50 w-sm-100 sm-fs-base gap-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", { class: "w-100 fw-light fs-sm mb-20" }, " Minimum 8 characters, One Uppercase, One Lowercase, One Symbol and One Number ", -1)
const _hoisted_10 = {
  key: 0,
  class: "w-100 pdb-20 text-danger fs-sm"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_PublicFooter = _resolveComponent("PublicFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "role",
              value: "P",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.credentials.role) = $event))
            }, null, 512), [
              [_vModelRadio, $setup.credentials.role]
            ]),
            _createTextVNode(" Participant ")
          ]),
          _createElementVNode("label", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "role",
              value: "L",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.credentials.role) = $event))
            }, null, 512), [
              [_vModelRadio, $setup.credentials.role]
            ]),
            _createTextVNode(" Local ")
          ]),
          _createElementVNode("label", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "role",
              value: "E",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.credentials.role) = $event))
            }, null, 512), [
              [_vModelRadio, $setup.credentials.role]
            ]),
            _createTextVNode(" Employer ")
          ])
        ]),
        _createElementVNode("form", {
          id: "login-form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)), ["prevent"])),
          method: "POST"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TextInput, {
              type: "email",
              label: "Email Address",
              placeholder: "Email",
              max: 50,
              modelValue: $setup.credentials.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.credentials.email) = $event)),
              "is-required": true,
              error: _ctx.errors?.email,
              required: true,
              "custom-class": "w-100 mb-20"
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_TextInput, {
              type: "password",
              label: "Password",
              placeholder: "Password",
              modelValue: $setup.credentials.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.credentials.password) = $event)),
              "is-required": true,
              error: _ctx.errors?.password,
              required: true,
              "custom-class": "mb-20"
            }, null, 8, ["modelValue", "error"]),
            _hoisted_9,
            ($setup.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.error), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_CheckBox, {
              label: "Remember me",
              id: "remember",
              showLabel: true,
              className: "text-x-large"
            })
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary w-sm-100 sm-fs-base",
            disabled: $setup.loading
          }, [
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Logging in..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "Login"))
          ], 8, _hoisted_11)
        ], 32)
      ])
    ]),
    _createVNode(_component_PublicFooter)
  ], 64))
}